module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-num",
    attrs: {
      "id": "C3"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('p', {
    staticClass: "chap-title"
  }, [_vm._v("GEORGE PULLMAN IN NEW YORK")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("George Mortimer Pullman grew up in a New York family that made things. Lewis Pullman, his father, was a carpenter in Salem Cross Roads (later called Brockton), New York, the town where George was born on March 3, 1831. Being a skilled carpenter, Mr. Pullman was probably paid the top salary, three dollars a day."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN15",
      "id": "FT15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" Lewis and his wife, Emily, had ten children, two of whom died young. George’s two older brothers, Royal Henry and Albert, also became carpenters and later established a cabinetmaking business."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN16",
      "id": "FT16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" In addition to carpentry, George’s father found employment moving buildings, a job that often required him to spend time away from home."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN17",
      "id": "FT17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" An inventor as well, in 1841 Lewis patented a machine to make it easier to move them."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN18",
      "id": "FT18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the spring of 1845, fourteen-year-old George, having finished the fourth grade, quit school and went to work at his uncle’s store, where he learned a great deal about commerce and merchandising. Later that year, his parents and younger siblings moved to Albion, New York, right on the Erie Canal, so that Lewis could be closer to his work. The three older boys all stayed at Salem Cross Roads.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After three years, the boys joined their parents in Albion. Henry and Albert opened a cabinetmaking shop, and George became an apprentice cabinetmaker. Later, George worked for his father, often serving as the fixer whenever problems arose."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN19",
      "id": "FT19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" So, when Lewis Pullman died in 1853, George, then just twenty-two and the oldest unmarried son, took over his father’s moving business, entering into a partnership with a fellow Albion resident, Charles Henry Moore. George cared for his widowed mother, Emily, the rest of her life.")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/P21-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The Erie Canal, darkened for effect, made it easier for settlers to get from the East Coast to the Middle West. "), _c('i', [_vm._v("Mitchell, 1865")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the State of New York decided to widen the Erie Canal, it contracted with Pullman and Moore to move twenty or more buildings away from the expanded canal right-of-way."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN20",
      "id": "FT20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" For the next six years, they and six to twelve hired men worked on this project six days a week.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At five feet, seven inches tall and 160 pounds, George Pullman was a man of average build, but he looked young for his age."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN21",
      "id": "FT21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" This undoubtedly influenced his decision to grow facial hair, which he kept the rest of his life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As he worked alongside the canal, George Pullman must have realized that travel by train would soon eclipse travel by canal. Trains were faster and, more importantly, could continue to operate all winter. So, he paid attention when a friend of his, former state senator Benjamin Field, began building sleeping cars for the New York Central Railroad.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Travel by rail at that time was cheaper and faster than other modes of transportation but not at all comfortable."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN22",
      "id": "FT22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" George Pullman once described the three-and-a-half-day trip from New York to Chicago as a “nightmare.” Besides being uncomfortable while on the train, there was no one direct route. One then expected to have to change trains at least once, and there might be a long delay at any one station waiting for one’s connecting trip."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN23",
      "id": "FT23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" Many travelers did at least plan their trips so that come evening they could disembark and spend the night at a comfortable hotel near the depot.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not long afterward, on a trip by railroad to Buffalo, George examined one of the train’s sleepers. Like other sleepers at that time, it had vertical tiers of three berths—one near the floor with a fee of one dollar, one midway up that cost seventy-five cents and one near the ceiling that cost just fifty cents. He paid the dollar so that he could try out the expensive bed. He was disgusted; the bed was uncomfortable. Not only that, the ceiling was so low that a tall man wouldn’t be able to stand up straight. The car was unventilated, and the stoves at each end created a dreadful atmosphere. He didn’t sleep but wondered what could be done to make a better experience."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN24",
      "id": "FT24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" Shortly afterward, Pullman formed a sleeping car partnership with Senator Field."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN25",
      "id": "FT25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" But at that time, he didn’t have time to devote to this concern.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By coincidence, at some social event George Pullman met Mrs. Joel Matteson, the wife of the owner of the Matteson House Hotel in Chicago. She told him about the need to find some firm that could lift that hotel “out of the mud” and there were many other buildings in Chicago with the same need."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN26",
      "id": "FT26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So, when his moving contract with the State of New York ended in 1859—and seeing little hope for much more work in New York—George Pullman applied for and won the contract to raise Chicago’s Matteson Hotel. Before moving, however, he ordered one thousand jackscrews to be shipped to Chicago,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN27",
      "id": "FT27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" then the fastest-growing city in the country."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN28",
      "id": "FT28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a104c7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter3.vue
// module id = 84
// module chunks = 0